module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus/landing/smart-results-5eb05de698b96d2c240232cdd6b11f3e.png";